import { render, staticRenderFns } from "./onlineMargin.vue?vue&type=template&id=767fbbe4"
import script from "./onlineMargin.vue?vue&type=script&lang=js"
export * from "./onlineMargin.vue?vue&type=script&lang=js"
import style0 from "./onlineMargin.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports